module.exports = __webpack_public_path__ + "media/images/instagram-4551fddd.png";